/**
 * Judge.me header override for /pages/reviews
 *
 * Replaces the review count / average rating shown in the Judge.me widget
 * header (e.g. "4.90 ★ (30)") with the values in window.MM_JDGM_REVIEWS,
 * which theme.liquid fills from Judge.me's store-wide metafields.
 *
 * Judge.me renders (and re-renders) its widgets asynchronously, so a
 * MutationObserver re-applies the values whenever the widget changes.
 */
(() => {
  if (location.pathname.replace(/\/$/, '') !== '/pages/reviews') return;

  const config = window.MM_JDGM_REVIEWS || {};
  const count = parseInt(config.count, 10);
  const rating = parseFloat(config.rating);
  const hasCount = Number.isFinite(count) && count > 0;
  const hasRating = Number.isFinite(rating) && rating > 0 && rating <= 5;
  if (!hasCount && !hasRating) return;

  const countText = hasCount ? count.toLocaleString() : '';
  const ratingText = hasRating ? rating.toFixed(1) : '';

  function apply() {
    if (hasCount) {
      document.querySelectorAll('.jdgm-reviews-count').forEach((el) => {
        if (el.textContent.trim() !== countText) el.textContent = countText;
      });
    }

    if (hasRating) {
      document.querySelectorAll('.jdgm-rating-text').forEach((el) => {
        // The rating is the first text node, e.g. "4.90 " before the ★ span.
        const node = Array.from(el.childNodes).find(
          (n) => n.nodeType === Node.TEXT_NODE && /\d/.test(n.textContent)
        );
        const next = ratingText + ' ';
        if (node && node.textContent !== next) node.textContent = next;
      });

      document.querySelectorAll('.jdgm-average-rating .jdgm-stars[aria-label]').forEach((el) => {
        const label = `${rating.toFixed(1)} out of 5 stars`;
        if (el.getAttribute('aria-label') !== label) el.setAttribute('aria-label', label);
      });
    }
  }

  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      apply();
    });
  }

  function start() {
    apply();
    new MutationObserver(schedule).observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
